import { put, takeEvery, call } from '@redux-saga/core/effects';
import { get_recipes, get_recipes_error, get_recipes_success } from './reducer';

import api from '@service/DataService';

function* getRecipesSaga({ payload }) {
  try {
    const { page, limit, searchString } = payload;
    let search = ``;
    if (searchString) {
      search = `search=${searchString}`;
    }
    const requestRes = yield call(
      api.get,
      `/recipes?page=${page}&limit=${limit}&${search}`,
    );
    const responseData = requestRes.data;
    const response = responseData.data;
    yield put({
      type: get_recipes_success.type,
      payload: response,
    });
  } catch (error) {
    yield put({
      type: get_recipes_error.type,
    });
  }
}

function* recipesSagas() {
  yield takeEvery(get_recipes.type, getRecipesSaga);
}

export default recipesSagas;
